module.exports = __webpack_public_path__ + "img/new-appoint-btn.fbe3f4ec.png";